import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "shared/components/Icons";
import { RenderIf } from "shared/components";
import "./PageTitle.scss";

const PageTitle = ({
  text,
  innerTitle,
  onBackClickHandler,
  isShared,
  isButton,
  button,
  fallbackUrl,
}) => {
  const navigate = useNavigate();
  const backButtonClickHandler = () => {
    if (onBackClickHandler) {
      onBackClickHandler();
    } else if (
      document.referrer &&
      document.referrer.includes(window.location.origin) &&
      window.history.length > 1
    ) {
      navigate(-1);
    } else if (fallbackUrl) {
      navigate(fallbackUrl);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="pageTitleMain">
      <div className="d-flex align-items-center justify-content-between">
        <h1>{text}</h1>
        <RenderIf condition={isShared}>{button}</RenderIf>
      </div>
      <RenderIf condition={innerTitle}>
        <div className="d-flex align-items-center justify-content-between my-4">
          <div className="pageTitleMainInner">
            <button
              type="button"
              className="pageTitleMainInnerButton"
              onClick={backButtonClickHandler}>
              <ArrowLeft />
            </button>
            <h4>{innerTitle}</h4>
          </div>
          <RenderIf condition={isButton}>{button}</RenderIf>
        </div>
      </RenderIf>
    </div>
  );
};

export default PageTitle;
